<template>
  <v-card color="background" class="mx-5 pt-5" flat height="100%">
    <v-container fluid class="px-0">
      <v-row no-gutters>
        <v-col cols="12" sm="8" md="8">
          <v-card-title class="pt-0 pl-1 pb-2">
            {{ $t("views.serviceLog.requestService") }}
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 mb-12 pb-12 px-0">
      <v-container
        fluid
        class="text-center"
        v-if="fetchResponsiveDealerLoading"
      >
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-overlay :opacity="1" color="background">
              <v-progress-circular
                indeterminate
                :width="4"
                color="primary"
              ></v-progress-circular>
            </v-overlay>
          </v-col>
        </v-row>
      </v-container>
      <v-form lazy-validation ref="req-assistance-form" v-else>
        <v-container fluid class="px-0" no-gutters>
          <v-card
            :loading="loading"
            class="px-6 pb-2"
            :class="{ 'pt-6': !loading }"
          >
            <v-row
              align="center"
              justify="center"
              no-gutters
              :class="{ 'mt-6': loading }"
            >
              <v-col cols="12" sm="8" md="4">
                <v-card-text class="pa-0 mb-3">
                  <span>
                    {{
                      $t(
                        "views.serviceLog.youAreAboutToReachOutToForAssistanceWithServicingYourBoat",
                        { responsiveDealer: responsiveDealer.name }
                      )
                    }}
                  </span>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="8" md="4">
                <v-card-text class="pa-0">
                  <v-textarea
                    class="mt-4"
                    outlined
                    auto-grow
                    name="assistanceMessage"
                    :label="$t('views.serviceLog.enterYourMessage')"
                    v-model="assistanceMessage"
                    :rules="reqAssistanceMessageRules"
                    :hint="$t('views.serviceLog.messageForServicingPartner')"
                    required
                  ></v-textarea>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-form>
    </v-container>
    <v-container fluid class="px-0 pb-0 button--bottom">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-btn @click="save()" block color="primary" class="button mx-auto">
            <!-- <v-icon left>mdi-plus</v-icon> -->
            {{ $t("views.serviceLog.send") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import {
  generalAssistanceRequest,
  fetchResponsiveDealer,
} from "@/api/log-entries";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      assistanceMessage: "",
      reqAssistanceMessageRules: [],
      loading: false,
      responsiveDealer: null,
      fetchResponsiveDealerLoading: true,
    };
  },
  created() {
    this.setInitailData();

    this.fetchResponsiveDealerLoading = true;
    fetchResponsiveDealer(this.getAccessToken, this.getUserBoatId).then(
      (response) => {
        this.responsiveDealer = response.current_partner;
        this.fetchResponsiveDealerLoading = false;
      }
    );
  },

  computed: {
    ...mapGetters(["getUserBoatId", "getAccessToken"]),
  },
  methods: {
    setInitailData() {
      this.reqAssistanceMessageRules = [
        (v) => !!v || this.$t("views.serviceLog.messageIsRequired"),
        (v) =>
          (v && v.length > 10) || this.$t("views.serviceLog.messageIsTooShort"),
      ];
      this.assistanceMessage = this.$route.params.message;
    },
    save() {
      let valid = this.$refs["req-assistance-form"].validate();

      if (!valid) {
        return;
      }
      // TODO: only load on the dialog, not here
      this.loading = true;

      generalAssistanceRequest(
        this.getAccessToken,
        this.getUserBoatId,
        this.assistanceMessage
      )
        .then(() => {
          this.loading = false;
          this.assistanceMessage = "";
          this.$router.back();
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.headline--title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: black;
}

.button--bottom {
  position: absolute;
  width: 100%;
  bottom: 40px;
}
</style>
